export class IntegrationAuthRequest {
    organizationId: string;

    constructor(organizationId: string) {
        this.organizationId = organizationId;
    }
}